module.exports = __webpack_public_path__ + "7c8a7dce02f9d4882999d9c32b5ef745.svg";